/**
 * How a deadline READS. Shared by the desk and by the drawer's insights lens so
 * the same clock never gets two different English descriptions on one screen.
 *
 * Formatting only — the deadline itself is derived by service 0009's case
 * trigger and read from `service.sla_clock`. Nothing here computes one.
 */

/** "in 24m" / "2h overdue" — the deadline in the unit a desk actually thinks in. */
export function untilLabel(dueAt: string | null | undefined): string {
  if (!dueAt) return '—'
  const mins = Math.round((Date.parse(dueAt) - Date.now()) / 60_000)
  const abs = Math.abs(mins)
  const unit = abs >= 2880 ? `${Math.round(abs / 1440)}d` : abs >= 120 ? `${Math.round(abs / 60)}h` : `${abs}m`
  return mins < 0 ? `${unit} overdue` : `in ${unit}`
}

export const fmtWhen = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString(undefined, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—'

export const obligationLabel = (o: string | null | undefined) =>
  o === 'first_response' ? 'First response' : o === 'resolution' ? 'Resolution' : (o ?? '—')
